An array of methods for applying to the position.

If no methods are provided, SEEK's Apply Form will be used to receive candidate applications.
SEEK's Apply Form will emit a `CandidateApplicationCreated` event that points to a `CandidateProfile` object.

Scheme requirements:

- For the `seekAnz` scheme, this field is limited to a single element.
  Requests with more than 1 element will fail.
